import React from 'react';/*
import { Bar, Line } from 'react-chartjs-2';*/
import PopoverHelper from '../../../../utils/PopoverHelper';
import {
  PresenterReadMyAssetSummary as Presenter 
} from '../../../../home/presenter.js'
import {
  ReadPropsMyAssetSummary as Read
} from '../../../../home/helper/request.props.js';
//Icon
import iconMaping from '../../../../utils/IconMaping.js'; 
import windowStop from '../../../../utils/windowStop';
import lang from 'config/language' 

export default class Chart extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          ChartData1      : {
            labels          : ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            data            : [65, 0, 0, 0, 0, 0, 0]
          },
          tenant          : this.props.tenant,
          totalMyAsset    : 0,
          totalThisMonth  : 0,
          totalThisWeek   : 0,
          totalOverdue    : 0,
          loading         : true
        }
    }

    loadData(){
      Presenter(
        Read('Read', this, this.onReadSuccess.bind(this), this.onReadFailed.bind(this))
      )
    }

    onReadSuccess(params, response){
      this.setState({
        totalMyAsset    : response.data.MyAsset,
        // totalThisMonth  : response.data.AssetDueDateMonth,
        totalThisMonth  : response.data.ServiceMonth,
        totalThisWeek   : response.data.ServiceWeek,
        totalOverdue    : response.data.ServiceOverDue,
        loading         : false
      })
    }

    onReadFailed(params, response){

    }

    handleTabClick(number){ 
      this.props.SetSummaryTab(number);
    }

    componentDidMount(){
      this.loadData()
    }

    componentWillUnmount() {
      windowStop()
    }

    render() {
      //const disabledStyle = {pointerEvents: 'none'}
        return (
          <div className="row">
            <div className="col-sm-6 col-lg-3">
              <div role = "button" onClick={() => this.handleTabClick(1)} className="card card-inverse card-primary">
                <div className="card-block pb-0">
                  <button type="button" className="btn btn-transparent active p-0 float-right">
                    <i className={iconMaping.AVICON_DIAMOND}></i>
                  </button>
                  <h4 className="mb-0">
                    {this.state.totalMyAsset}
                    <PopoverHelper 
                      id="my_asset"
                      iconSize="14px"
                      content={lang.dashboard.my_asset}
                    />
                  </h4>
                  <p className={"mb-0 truncate"}>My Asset</p>
                  <p className={"mb-0 fs-12 truncate text-muted"}>Total my tools</p>
                </div>
                <div className="chart-wrapper px-3" style={{ height: 30 + 'px' }}>
                  {/*<Line data={cardChartData1} options={cardChartOpts1} height={70}/>*/}
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-lg-3">
              <div role = "button" onClick={() => this.handleTabClick(2)} className="card card-inverse card-success">
                <div className="card-block pb-0">
                  <button type="button" className="btn btn-transparent active p-0 float-right">
                    <i className="icon-clock"></i>
                  </button>
                  <h4 className="mb-0">
                    {this.state.totalThisMonth}
                    <PopoverHelper 
                      id="popover2"
                      iconSize="14px"
                      content={lang.dashboard.this_month}
                    />
                  </h4>
                  <p className={"mb-0 truncate"}>This Month</p>
                  <p className={"mb-0 fs-12 truncate text-muted"}>Tools that are due for service this month</p>
                </div>
                <div className="chart-wrapper px-3" style={{ height: 30 + 'px' }}>
                  {/*<Line data={cardChartData2} options={cardChartOpts2} height={70}/>*/}
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-lg-3">
              <div role = "button" onClick={() => this.handleTabClick(3)} className="card card-inverse card-warning">
                <div className="card-block pb-0">
                  <button type="button" className="btn btn-transparent active p-0 float-right">
                    <i className="icon-clock"></i>
                  </button>
                  <h4 className="mb-0">
                    {this.state.totalThisWeek}
                    <PopoverHelper 
                      id="popover3"
                      iconSize="14px"
                      content={lang.dashboard.this_week}
                    />
                  </h4>
                  <p className={"mb-0 truncate"}>This Week</p>
                  <p className={"mb-0 fs-12 truncate text-muted"}>Tools that are due for service this week</p>
                </div>
                <div className="chart-wrapper px-3" style={{ height: 30 + 'px' }}>
                  {/*<Line data={cardChartData3} options={cardChartOpts3} height={70}/>*/}
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-lg-3">
              <div role = "button" onClick={() => this.handleTabClick(4)} className="card card-inverse card-danger">
                <div className="card-block pb-0">
                  <button type="button" className="btn btn-transparent active p-0 float-right">
                    <i className="icon-clock"></i>
                  </button>
                  <h4 className="mb-0">
                    {this.state.totalOverdue}
                    <PopoverHelper 
                      id="popover4"
                      iconSize="14px"
                      content={lang.dashboard.overdue}
                    />
                  </h4>
                  <p className={"mb-0 truncate"}>Overdue</p>
                  <p className={"mb-0 fs-12 truncate text-muted"}>Tools that have past the service date and no action has been taken</p>
                </div>
                <div className="chart-wrapper px-3" style={{ height: 30 + 'px' }}>
                  {/*<Line data={cardChartData4} options={cardChartOpts4} height={70}/>*/}
                </div>
              </div>
            </div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/Chart/Chart.js